import {
  textFormat,
  audioFormat,
  videoFormat,
  pictureFormat,
  archiveFormat,
} from './listOfFilesFormat';
import { LocalIconTypes } from '../../ui/LocalIcon';

export function checkFileFormat(format: string): LocalIconTypes {
  if (textFormat.includes(format)) {
    return 'text.svg';
  } else if (audioFormat.includes(format)) {
    return 'music-square.svg';
  } else if (videoFormat.includes(format)) {
    return 'video-play.svg';
  } else if (pictureFormat.includes(format)) {
    return 'image.svg';
  } else if (archiveFormat.includes(format)) {
    return 'zip.svg';
  } else {
    return 'unknown-file.svg';
  }
}

export function getFileType(type: string) {
  if (textFormat.includes(type)) {
    return 'text';
  } else if (audioFormat.includes(type)) {
    return 'music';
  } else if (videoFormat.includes(type)) {
    return 'video';
  } else if (pictureFormat.includes(type)) {
    return 'image';
  } else if (archiveFormat.includes(type)) {
    return 'zip';
  } else {
    return 'unknown-file';
  }
}

export function getMimeType(ext: string): string {
  const map: Record<string, string> = {
    pdf: 'application/pdf',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    webp: 'image/webp',
    mp4: 'video/mp4',
    mp3: 'audio/mpeg',
    json: 'application/json',
    txt: 'text/plain',
    csv: 'text/csv',
  };
  return map[ext] || 'application/octet-stream';
}
